import { render, staticRenderFns } from "./ViewCustomField.vue?vue&type=template&id=12ebe5d0&"
import script from "./ViewCustomField.vue?vue&type=script&lang=js&"
export * from "./ViewCustomField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports